/** Fuente de datos del wizard de workspace (grupo empresa → empresa → sucursal).
 *
 * Grupo y empresa salen del mismo endpoint (`GET Grupoempresas`), que devuelve cada grupo
 * con sus empresas embebidas; se cachea el resultado para no repetir la llamada entre pasos.
 * Las sucursales por empresa todavía no tienen endpoint (pendiente).
 */
import { GETGruposEmpresa } from "@/api";
import type { EmpresaGrupo, GrupoEmpresa, Sucursal } from "@/types";

let cacheGrupos: GrupoEmpresa[] | null = null;

const cargarGrupos = async (): Promise<GrupoEmpresa[]> => {
  if (cacheGrupos) return cacheGrupos;
  const res = await GETGruposEmpresa();
  cacheGrupos = res.success && Array.isArray(res.data) ? res.data : [];
  return cacheGrupos;
};

/** Grupos empresa disponibles para el usuario. */
export const getGruposEmpresa = (): Promise<GrupoEmpresa[]> => cargarGrupos();

/** Empresas del grupo empresa elegido (vienen embebidas en la respuesta de grupos). */
export const getEmpresas = async (codGrupoEmpresa: string): Promise<EmpresaGrupo[]> => {
  const grupos = await cargarGrupos();
  return grupos.find((g) => g.codigo === codGrupoEmpresa)?.empresas ?? [];
};

/** Sucursales de la empresa elegida. */
export const getSucursalesDeEmpresa = async (_codEmpresa: string): Promise<Sucursal[]> => {
  // TODO(datos): endpoint de sucursales por empresa.
  return [];
};
